import React from 'react';
import { isUndefined } from 'lodash'
import { Checkbox, Tooltip } from 'antd';
import { hasPermission } from 'utils/authService';

const AuthorisedCheckbox = ({ tooltipTitle = "No access to change.", permission, ...rest }) => {
    return (!isUndefined(permission) && !hasPermission(permission)) ? <Tooltip title={tooltipTitle}><Checkbox {...rest} disabled /></Tooltip> : <Checkbox {...rest} />;
}

export default AuthorisedCheckbox;